<template lang="pug">
    div(v-if="currentStep.data")
        lessonHeader
        stepTitle
        v-layout.module(row wrap)
            v-flex.button-container(xs1)
                div.total-container
                div.prev(@click="prevStep")
                    font-awesome-icon(icon="arrow-left")
            v-flex.back-blue(xs3)
                div.total-container
                    div.titulo-e TOTAL DE GASTOS:
                    div.total-value-e {{ currentStep.data.expensesTotal | toCurrency }}.00
                v-navigation-drawer.nav(dark height="auto")
                    v-list
                        v-list-tile.item(v-for="item in items" 
                            :key="item.title"
                            @click="changeItem(item)"                            
                            :class="{activeitem:currentItem === item}")
                            v-list-tile-action
                                v-icon {{ item.icon }}                     
                            v-list-tile-content
                                v-list-tile-title {{ item.title }}                            
            v-flex.card00.flex(xs7 v-for="item in items" v-if="currentItem === item")
                div.title-e Promedio de tus gastos mensuales por               
                div.title-e {{item.title}}
                v-spacer.py-2
                div.text-e Agrega el promedio de tus gastos mensuales y marca la casilla si realizas el pago con tu tarjeta de crédito.
                v-spacer.py-2
                v-layout(row wrap)
                    v-flex.flex-space(xs6)
                        div GASTOS FIJOS
                        v-spacer.py-2
                        div(v-for="fixed in item.fixeds")
                            label.label-e {{fixed.label}}
                            v-layout.lay-relative(row wrap)
                                v-flex.flex-space(xs10)
                                    v-text-field(prefix="$" v-model="fixed.value" @input="changeExpense(fixed)"  @keyup="format(fixed)")
                                v-flex.flex-space(xs2)
                                    v-checkbox.check-text(v-model="fixed.paybycard")
                    v-flex.flex-space(xs6) 
                        div GASTOS VARIABLES
                        v-spacer.py-2
                        div(v-for="variable in item.variables")
                            label.label-e {{variable.label}}
                            v-layout.lay-relative(row wrap)
                                v-flex.flex-space(xs10)
                                    v-text-field(prefix="$" v-model="variable.value" @input="changeExpense(variable)" @keyup="format(variable)")
                                v-flex.flex-space(xs2)
                                    v-checkbox.check-text(v-model="variable.paybycard")
        v-spacer.py-2
        el-button.b-calculate(type="success" :disabled="bCalculateDisabled" @click="nextStep") Calcular mi presupuesto        
        lessonFooter
        
</template>

<script>

import { mapGetters, mapActions, mapMutations } from 'vuex';
import lessonHeader from "@/components/lesson-header/lesson-header";
import stepTitle from '@/components/step-title/step-title'
//import presupuesto from '@/components/presupuesto/presupuesto'
import ButtonNext from "@/components/button-next/button-next";
import lessonFooter from "@/components/lesson-footer/lesson-footer";
import imageLoader from "@/components/image-loader/image-loader";
import {currencyFormat} from "@/utils/utils";

export default {
  name: 'Expenses',
  components:{
	lessonHeader,    
	stepTitle,           
    lessonFooter,
    imageLoader,
    ButtonNext
  },
  computed: {
    ...mapGetters(['currentStep','currentGroup'])    
  },
  created() {
      this.currentItem = this.items[0];
      this.currentStep.data.expensesTotal = 0;
  },
  data () {    
    return {
        currentItem: null,
        bCalculateDisabled: true,
        items: [
            { title: 'Alimentos y consumo', icon: 'shopping_basket',
                fixeds: [ { label:'Despensa' }, { label:'Otro gasto' } ],
                variables: [ { label:'Comida fuera de casa' }, { label:'Otro gasto' } ] 
            },
            { title: 'Casa', icon: 'home',
                fixeds: [ { label:'Renta' }, { label:'Mantenimiento y servicios' } ],
                variables: [ { label:'Muebles, articulos para el hogar' }, { label:'Otro gasto' } ] 
             },
            { title: 'Salud', icon: 'local_hospital',
                fixeds: [ { label:'Fondo de salud, seguros' }, { label:'Gimnasio, club deportivo' } ],
                variables: [ { label:'Doctor, medicinas' }, { label:'Otro gasto' } ] 
            },
            { title: 'Transporte', icon: 'directions_car',
                fixeds: [ { label:'Gasolina' }, { label:'Transporte público' } ],
                variables: [ { label:'Mantenimiento auto' }, { label:'Otro gasto' } ]
            },
            { title: 'Educación', icon: 'school',
                fixeds: [ { label:'Colegiaturas' }, { label:'Libros, cuadernos, útiles' } ],
                variables: [ { label:'Uniformes' }, { label:'Otro gasto' } ]
            },
            { title: 'Esparcimiento', icon: 'local_movies', 
                fixeds: [ { label:'Vacaciones' }, { label:'Otro gasto' } ],
                variables: [ { label:'Cine, teatro, fistas, salidas' }, { label:'Otro gasto' } ]
            },
            { title: 'Créditos', icon: 'credit_card',
                fixeds: [ { label:'Créditos' }, { label:'Otro gasto' } ],
                variables: [ { label:'Otro gasto' }, { label:'Otro gasto' } ]
            }
        ]
    }
  },  
  methods: {    
    ...mapActions(['nextStepSCORM']),
    ...mapMutations(['setCurrentGroup', 'setCurrentStep']),
    nextStep() {
        this.currentStep.data.items = this.items;
        this.nextStepSCORM()
    },
    changeItem(item) {
        this.currentItem = item;
        item.visited = true;                         
    },
    changeExpense(expense) {        
        this.currentStep.data.expensesTotal = 0;
        this.items.forEach(i => {
            i.fixeds.forEach(f => {
                if (f.value) {
                    const value = Number(f.value.replace(/\,/g, ''));
                    if (value) {
                        this.currentStep.data.expensesTotal += value;
                    }
                }
            });
            i.variables.forEach(v => {
                if (v.value) {
                    const value = Number(v.value.replace(/\,/g, ''));
                    if (value) {
                        this.currentStep.data.expensesTotal += value;
                    }
                }
            });
        });

        if (this.currentStep.data.expensesTotal > 0) {
           this.bCalculateDisabled = false;
        } else {
           this.bCalculateDisabled = true;
        }
    },
    prevStep() {        
      if(this.currentStep.index > 0) {
        const step = this.currentGroup.steps[this.currentStep.index - 1];
        step.transition = 'none';
        this.setCurrentStep(step);
      }
    },
    format (expense) {
        expense.value = currencyFormat(expense.value );
	}
  }
}
</script>

<style scoped>
@import 'expenses.scss';
</style>
